var swiper = new Swiper(".supportSliders", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView:2.4,
        spaceBetween:8,
      },
      768: {
        slidesPerView:3.6,
        spaceBetween:20,
      },
      1024: {
        slidesPerView:5,
        spaceBetween:30,
      },
    },
  });